import React, { useEffect, useState, useCallback } from 'react';
import { getBlogPagePosts } from '../../../api/services/blogPostsApi';

import BlogLayout from '../../../components/main/blog/BlogLayout/BlogLayout';
import BlogPostExcerptsList from '../../../components/main/blog/BlogPostExcerptsList/BlogPostExcerptsList';
import BlogSideBar from '../../../components/main/blog/BlogSideBar/BlogSideBar';

import './Blog.css';

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [totalPosts, setTotalPosts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const postsPerPage = 6;

  const fetchBlogPosts = useCallback(async () => {
    setIsLoading(true);

    try {
      const res = await getBlogPagePosts({
        page: currentPage,
        limit: postsPerPage,
      });

      setBlogPosts(res.data || []);
      setTotalPosts(res.total || 0);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, [currentPage]);

  useEffect(() => {
    fetchBlogPosts();
  }, [fetchBlogPosts]);

  if (isLoading) return <p>Loading...</p>;

  return (
    <div className='blog-page-container'>
      <div className='blog-title-container'>
        <h1 className='blog-title'>BLOG</h1>
      </div>

      <BlogLayout sidebar={<BlogSideBar />}>
        <BlogPostExcerptsList
          blogPosts={blogPosts}
          totalPosts={totalPosts}
          postsPerPage={postsPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={isLoading}
        />
      </BlogLayout>
    </div>
  );
};

export default Blog;
